import React from "react";

export const GameState = React.createContext();
